import { District, School } from 'app/dto';
import { TypeGuards } from '../../type-guards';

export * as StringUtilities from './string-utilities';

export function FormatStringForUrl(input: string): string {
    // Remove all non-alphanumeric characters except spaces
    const alphanumericWithSpaces = input.trim().replace(/[^a-zA-Z0-9 ]/g, '');
  
    // Replace consecutive spaces with a single space
    const singleSpaced = alphanumericWithSpaces.replace(/\s+/g, ' ');
  
    // Replace spaces with dashes
    const result = singleSpaced.replace(/ /g, '-');
  
    return result;
  }

export function capitalizeFirstLetter(str: string): string {
  if (!str) return str;  // Handle empty strings
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function createScopeClaim(entity: District | School, permission: string = 'read'): string {
  if (TypeGuards.isDistrict(entity)) {
    return `district://${permission}@${entity.districtId}?m=${entity.districtNumber}`;
  } else if (TypeGuards.isSchool(entity)) {
    return `school://${permission}@${(entity as School).schoolId}?m=${(entity as School).schoolNumber}`;
  }
  return '';
}